import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { EMPLOYEE_REPORTING_SCOPE, getScopeColor, getScopeTextColor, getScopeText } from '../../../constants/employeeReportingScope';

const EmployeeReportingScope = ({
  selectedScope = '',
  onScopeChange,
  disabledScopes = [],
  // ADR-092: render all chips greyed out and non-interactive (e.g. until a
  // representative is selected), as opposed to disabledScopes which hides them.
  disabled = false,
  // ADR-092: per-scope label overrides, e.g. { hierarchy: 'Hierarchy' } when
  // the scope applies to a selected representative rather than the viewer.
  labelOverrides = {},
  sx = {}
}) => {
  const scopes = Object.values(EMPLOYEE_REPORTING_SCOPE).filter(
    scope => !disabledScopes.includes(scope)
  );

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {scopes.map((scope) => (
        <FilterChip
          key={scope}
          label={labelOverrides[scope] || getScopeText(scope)}
          isSelected={selectedScope === scope}
          onClick={() => onScopeChange(scope)}
          backgroundColor={getScopeColor(scope)}
          textColor={getScopeTextColor(scope)}
          borderColor={getScopeTextColor(scope)}
          showDot={true}
          disabled={disabled}
        />
      ))}
    </Box>
  );
};

export default EmployeeReportingScope;
